// SecondPart.js
import React from "react";
import { useIsDesktop } from "../../../hooks/useIsDesktop";
import { useFetchLoans } from "../../../hooks/fetch-data/useFetchLoans";
import LoanProductCard from "../../../components/card/MainLoanProductCard";
import { useTranslation } from "react-i18next";
import LoanRegisterButton from "../../../components/button/LoanRegisterButton";

const CARD_WIDTH = 268; // Width of each card in pixels
const MAX_COLUMNS = 4; // Maximum columns on desktop

const SecondPart = () => {
  const isDesktop = useIsDesktop();

  const { data: loans, isLoading, error } = useFetchLoans();
  const { t } = useTranslation("secondPart");

  // Determine how many columns we actually need on desktop:
  //   If there are 0 loans, treat as 1 column so the “no loans” message is centered.
  //   Otherwise, use the number of loans (capped at MAX_COLUMNS).
  const desktopColumnCount = Math.min(
    Math.max(loans?.length || 1, 1),
    MAX_COLUMNS
  );

  return (
    <section
      style={{
        width: "100%",
        padding: isDesktop ? "60px 80px" : "24px 16px",
        background:
          "linear-gradient(18deg, #FF6500 43.24%, #FF8533 84.37%), linear-gradient(51deg, #FF7519 19.46%, #FF9240 81.38%)",
        textAlign: "center",
        boxSizing: "border-box",
      }}
    >
      <h2
        style={{
          fontSize: isDesktop ? "32px" : "24px",
          fontWeight: 600,
          color: "#ffffff",
          marginBottom: "20px",
          marginTop: "20px",
        }}
      >
        {t("ourLoan")}
      </h2>

      <div
        style={{
          width: "128px",
          height: "4px",
          background: "#10B48F",
          margin: "0 auto 40px",
          borderRadius: "20px",
        }}
      />

      {isLoading && (
        <p style={{ color: "white", fontSize: "16px", marginBottom: "24px" }}>
          {t("loading")}
        </p>
      )}

      {error && (
        <p style={{ color: "white", fontSize: "16px", marginBottom: "24px" }}>
          {t("error")}
        </p>
      )}

      {!isLoading && !error && (
        <div
          style={{
            display: "grid",
            // On desktop: repeat N columns of fixed width (268px).
            // On mobile: a single column (1fr).
            gridTemplateColumns: isDesktop
              ? `repeat(${desktopColumnCount}, ${CARD_WIDTH}px)`
              : "1fr",
            gap: isDesktop ? "24px" : "16px",
            // Center the entire “grid” block on desktop
            justifyContent: isDesktop ? "center" : undefined,
            // On mobile, center each single-column card
            justifyItems: isDesktop ? undefined : "center",
          }}
        >
          {loans && loans.length > 0 ? (
            loans.map((loan) => (
              <div
                key={loan.id}
                style={{
                  width: "100%",
                  maxWidth: `${CARD_WIDTH}px`,
                }}
              >
                <LoanProductCard loan={loan} />
              </div>
            ))
          ) : (
            <p style={{ color: "white", fontSize: "16px" }}>{t("notFound")}</p>
          )}
        </div>
      )}

      <div style={{ marginTop: "32px" }}>
        <LoanRegisterButton />
      </div>
    </section>
  );
};

export default SecondPart;
